import React, { FC, useEffect } from 'react';
import { TableActions, Button } from './style';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InternalContainer from 'components/internal-container/internal-container';
import { paginatedResponse } from 'models/campanhas';
import { UseCampanhaContext } from 'context/campanha-context';
interface paginationProps {
  handlePageChange: (p: number) => void;
  paginatedResponse: paginatedResponse;
}

const Pagination: FC<paginationProps> = ({
  paginatedResponse,
  handlePageChange,
}) => {
  const { page, setPage } = UseCampanhaContext();
  const TOTAL_PAGES = paginatedResponse.total_paginas;
  const TOTAL_REGISTROS = paginatedResponse.total_resultados;
  const interval = {
    inicio: page === 1 ? 1 : (page - 1) * 10 + 1,
    fim:
      page === TOTAL_PAGES && TOTAL_REGISTROS % 10 !== 0
        ? (TOTAL_REGISTROS % 10) + (page - 1) * 10
        : page * 10,
  };
  useEffect(() => {
    handlePageChange(page);
  }, [page]);

  return (
    <TableActions align="center" justify="space-between">
      <p>
        Mostrando {interval.inicio} a {interval.fim} de {TOTAL_REGISTROS}
      </p>
      <InternalContainer width="max-content" justify="space-between">
        <InternalContainer>
          <Button
            arrow
            onClick={() => {
              page > 1 && setPage(page - 1);
            }}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>
          {[...Array(TOTAL_PAGES)].map((value, index) => (
            <Button
              key={index}
              type="button"
              onClick={() => setPage(index + 1)}
              active={page === index + 1}
            >
              {index + 1}
            </Button>
          ))}
          <Button
            arrow
            onClick={() => {
              page < TOTAL_PAGES && setPage(page + 1);
            }}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </Button>
        </InternalContainer>
      </InternalContainer>
    </TableActions>
  );
};

export default Pagination;
